export default __webpack_public_path__ + "static/media/personal-liability.4406f712.jpg";